import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M106-425v-356q0-30 22-52t51-22h274v430H106Zm274-73Zm127-357h274q30 0 52 22t22 52v192H507v-266Zm0 749v-429h348v356q0 29-22 51t-52 22H507ZM106-371h347v265H179q-29 0-51-22t-22-51v-192Zm274 72Zm200-362Zm0 199Zm-401-36h201v-283H179v283Zm401-163h201v-120H580v120Zm0 199v283h201v-283H580ZM179-299v120h201v-120H179Z"/>',
  f: '<path d="M106-425v-356q0-30 22-52t51-22h274v430H106Zm401-430h274q30 0 52 22t22 52v192H507v-266Zm0 749v-429h348v356q0 29-22 51t-52 22H507ZM106-371h347v265H179q-29 0-51-22t-22-51v-192Z"/>',
};

export default data;
